module.exports = __webpack_public_path__ + "static/media/TheoJames.bbbf3679.jpg";